module.exports = __webpack_public_path__ + "static/media/tystnad.d4b27f60.mp3";